import React from 'react'
import { Link } from 'react-router-dom'
import CryptoJS from 'crypto-js'
import Image from '../components/Image'
import RelativeDate from '../components/RelativeDate'
import ContentContainer from '../components/ContentContainer'
//import ContentLoader from '../components/ContentLoader'
import * as DataUtils from '../util/DataUtils'
import * as Utils from '../util/Utils'

export default class P extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      value: '',
    }
    this.onChange = this.onChange.bind(this)
    this.check = this.check.bind(this)
  }
  componentDidMount() {

  }
  componentDidUpdate(prevProps, prevState, snapshot) {

  }
  linkTo() {
    const content = this.props
    if (typeof(content)==='object'&&content!==null) {
      const type = content[DataUtils.TYPE]
      if (typeof(type)==='string'&&type.length>0) {
        const slug = content[DataUtils.SLUG]
        if (typeof(slug)==='string'&&slug.length>0) {
          return `/${type.toLowerCase()}/${slug}`
        }
        const id = content[DataUtils.ID]
        if (typeof(id)==='string'&&id.length>0) {
          return `/${type.toLowerCase()}/id/${id}`
        }
      }
    }
    return undefined
  }
  check() {
    let value = this.state.value
    if (typeof(value)==='string'&&value.length>0) {
      value = +value
    }
    if (typeof(value)==='number') {
      const hash = CryptoJS.MD5(`${value}`)
      const correct = this.props.a===hash.toString(CryptoJS.enc.Base64)
      this.setState({correct:correct})
    } else {
      this.setState({correct:false})
    }
  }
  onChange(event) {
    this.setState({value:event.target.value},this.check)
  }
  render() {
    const to = this.linkTo()
    return (
      <React.Fragment>
        {
          this.props.viewMode==='teaser'&&
          <div className="card">
            <Image {...this.props.images}
              imgClassName="card-img-top"
              maxWidth={312}
            />
            <div className="card-body">
              <h5 className="card-title">
                {this.props.name}
              </h5>
              <Tags values={this.props.tags} className="mb-2" />
              <p
                className="card-text"
                dangerouslySetInnerHTML={Utils.fromMd(this.props.details)}
              />
              {
                typeof(to)==='string'&&to.length>0&&
                <Link to={to}
                  className="btn btn-outline-success btn-sm"
                >Open</Link>
              }
              {
                typeof(this.props.onClick)==='function'&&
                <button
                  className="btn btn-outline-primary"
                  onClick={this.props.onClick}
                  >Read more</button>
              }
            </div>
          </div>
        }
        {
          (this.props.viewMode===undefined || this.props.viewMode==='full')&&
          <div className="container">
            <div className="mb-2"/>
            <Nav
              prev={this.props.prev}
              next={this.props.next}
            />
            <div className="post">
              <h1>
                {this.props.name}
                {
                  typeof(this.props.id)==='number'&&
                  <small className="ml-3">Problem {this.props.id}</small>
                }
              </h1>
              <div className="mb-2">
                <RelativeDate value={this.props._created} />
              </div>
              <Tags values={this.props.tags} className="mb-2" />
              <p
                className="lead"
                dangerouslySetInnerHTML={Utils.fromMd(this.props.details)}
              />
              {
                typeof(this.props.link)==='string'&&
                this.props.link.length>0&&
                <p><a href={this.props.link} target="_blank">Link to the original page</a></p>
              }
              <div className="input-group">
                <input className="form-control mr-2"
                  value={this.state.value}
                  onChange={this.onChange}
                />
                {
                  typeof(this.state.value)==='string'&& this.state.value.length>0&&
                  <div className="input-group-addon lead" >
                    {`${this.state.correct===true?'Correct':'Wrong'}`}
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </React.Fragment>
    )
  }
}

function Tags(props) {
  if (
    Array.isArray(props.values)&&
    props.values.length>0
  ) {
    return (
      <div className={props.className}>
        {
          props.values.map((tag,index)=>(
            <ContentContainer
              key={index}
              {...tag}
              className="mr-1"
            />
          ))
        }
      </div>
    )
  }
  return null
}

function Nav(props) {
  if (typeof(props)==='object'&&props!==null) {
    return (
      <div className="row mb-3">
        {
          false&&
          <pre><code>{JSON.stringify(props.prev,null,2)}</code></pre>
        }
        {
          typeof(props.prev)==='object'&&
          props.prev!==null&&
          <div className="col">
            <Link
              to={`/${props.prev[DataUtils.TYPE].toLowerCase()}/${props.prev[DataUtils.SLUG]}`}
              className="btn btn-outline-primary btn-sm"
            >
              <i className="fa fa-arrow-left"/> {props.prev.name}
            </Link>
          </div>
        }
        {
          typeof(props.next)==='object'&&
          props.next!==null&&
          <div className="col">
            <Link
              to={`/${props.next[DataUtils.TYPE].toLowerCase()}/${props.next[DataUtils.SLUG]}`}
              className="btn btn-outline-primary btn-sm float-right"
            >
              {props.next.name} <i className="fa fa-arrow-right"/>
            </Link>
          </div>
        }
      </div>
    )
  }
  return null
}

/*
aspectRatio:1.782
ext:".jpg"
id:"15226512766455d6e8391"
name:"15226512766455d6e8391.jpg"
function Image(props) {
  let src = '...'
  if (typeof(props)==='object'&&props!==null) {
    let image = props
    if (typeof(image[0])==='object'&&image[0]!==null) {
      image = image[0]
    }
    const fileName = image.name
    if (typeof(fileName)==='string'&&fileName.length>0) {
      const dataPath = `../data/`
      const imagesPath = `${dataPath}/images/w312h170`
      src = `${imagesPath}/${fileName}`
    }
  }
  return (
    <img
      className="card-img-top"
      src={src}
      alt=""
    />
  )
}
*/



// WEBPACK FOOTER //
// ./src/contents/P.js